<template>
    <ion-page>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-img class="logo" :src="require('@/assets/logo_full_small.png')"></ion-img>
                        <ion-card >
                            <Loading :msg="loadingMessage"></Loading>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
import Loading from '@/components/Loading.vue';
//import helpers from "@/helpers";

export default {
  name: 'federated-signin',
  components: {
    Loading,
  },
  data() {
    return {
      loadingMessage: this.$t('screens.federated-signin.loading'),
      count: 0,
      backOff: 1000,
    };
  },
  mounted() {
      this.checkLogin();
  },
  methods: {
      checkLogin: async function() {
          try {
              const user = await this.$Amplify.Auth.currentAuthenticatedUser();
              this.$logger.debug('signedIn', user);
              //const userDetails = await helpers.getUserDetails(user);
              //this.$logger.debug('ua', userDetails);

              this.$Amplify.Auth.userAttributes(user).then(res => {
                  this.$logger.debug(res);
                  // has gone through the initial setup
                  const found = res.find(function(element) {
                      if (element['Name'] == 'custom:fromCityId')
                          return element['Value'];
                      else
                          return false;
                  });

                  if(found) {
                      this.$logger.debug('found');
                      this.loadingMessage = this.$t('screens.federated-signin.signing-in');
                      this.$AmplifyEventBus.$emit('authState', 'signedIn');
                      //this.$router.push('/');
                  } else {
                      this.loadingMessage = this.$t('screens.federated-signin.will-complete');
                      this.$store.setSignedIn(true);
                      this.$store.setUser(user);
                      this.$router.push({name: 'location'});
                  }
              })
              .catch(err => {
                  this.$logger.error(err);
              });

              /*this.$store.setSignedIn(true);
              this.$store.setUser(user);*/
              //this.$AmplifyEventBus.$emit('authState', 'signedIn');
          } catch (err) {
              if (err.response && err.response.status === 401 || err == 'not authenticated') {
                  this.$logger.debug('unauthorized');
                  //this.$router.push('/welcome');
              }
              //this.$router.push('/welcome');
              this.$logger.debug('catch auth');
              this.count++;
              setTimeout(this.checkLogin, this.backOff + this.backOff * this.count);
          }
      }
  }
};
</script>

<style scoped>
    ion-content {
        --background: url('~@/assets/bg/bg7.jpg') no-repeat center center / cover;
    }

    >>> ion-card {
        --background: rgba(255,255,255,.8);
        font-family: 'Nunito', sans-serif;
        padding: 0;
        margin: .5em;
    }

    ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
        padding: 0;
    }

    ion-input {
        margin-left: .5em;
    }

    ion-footer ion-title {
        font-size: .8em;
        color: #666;
        font-weight: normal;
    }
</style>
